export const enUSStrings = {
	Ai_Button_Label: 'Ask Bailey',
	Ai_SubTitle: 'Powered by Barracuda IQ',
	Ai_Welcome_Message: 'Hello, I’m Bailey.',
	Ai_Welcome_Message_Subtitle:
		'Select a question below or write your own to get started.',
	Ai_Input_Placeholder: 'Ask your question',
	Ai_Input_Placeholder_Response: 'Type your response',
	AiQuestion_You: 'You',
	Thinking: 'Thinking...',
	Retry_Question: 'Retry question?',
	Ai_Answer_Generic_Error: 'I cannot answer that question right now.',
	Ai_Answer_Feedback_like_Question: 'Thanks for the feedback.',
	Ai_Answer_Feedback_dislike_Question:
		'I’m sorry to hear that my answer didn’t work for you. Can you let me know what I missed the mark on in the response box below? \n\nI will record your feedback and conclude our conversation. Would you like to proceed?',
	Yes: 'Yes',
	No: 'No',
	Ai_Answer_Feedback_Comment_Yes:
		'Ok, type your feedback in the response box below and I’ll take note and try to improve for you in the future!',
	Ai_Answer_Feedback_Comment_No: 'Sounds good.',
	Ai_Answer_Feedback_Comment_Continue:
		'You can continue the conversation below.',
	Ai_Answer_Feedback_Submitted: 'Your feedback has been recorded.',
	Ai_Answer_Cost_Limit_Reached:
		'You have exceeded the number of interactions allowed in this conversation. \n\nStart a new conversation by clicking the button below, and ask your question again.',
	Ai_Answer_Rate_Limit:
		"I'm limited to 40 responses in 60 minutes. Try back later.",
	Ai_Answer_Frequency_Limit:
		'I cannot answer that question right now. \n\nWait a few minutes, then you can retry your question by clicking below.',
	Ai_Answer_Bad_Input:
		'Your input contains elements that are not allowed or potentially dangerous content. Remove any code, scripts, or special characters and try again.',
	Ai_Answer_Content_Moderation:
		'Sorry about that. \n\nConstructive feedback helps me get better, so let me know what went wrong and how I can improve.',
	Ai_Answer_Sensitive_Information:
		'Your input contains sensitive information and cannot be processed.',
	Ai_Answer_Input_Too_Long:
		'Your input is too long. Please shorten it and try again.',
	Ai_Ask_New_Question: 'Ask a new question',
	Character_Limit: 'character limit',
	Ai_Sidebar_Warning:
		'This AI-powered assistant is intended to support users with product navigation and feature-related inquiries. User input and account context may be processed to enhance response accuracy for your interactions with the AI. For details on data usage and protection, please consult our <pna>Privacy Notice</pna>. If needed, human support is available through <a>www.barracuda.com/support/contact.</a>',
	Ai_Sidebar_New_Conversation: 'New conversation',
	Ai_Sidebar_Delete_Conversation: 'Delete conversation',
	Show_More: 'Show more',
	History: 'History',
	Ai_Sidebar_No_History: 'No history',
	Ai_Sidebar_Selected_Conversations_Count: '{phCount} selected',
	Ai_Sidebar_Historical_Conversations_Today: 'Today',
	Ai_Sidebar_Historical_Conversations_Yesterday: 'Yesterday',
	Ai_Sidebar_Historical_Conversations_Earlier: 'Earlier',
	About: 'About',
	Ai_Sidebar_AboutDescription1:
		'Bailey is an AI assistant that answers your questions about Barracuda products and services and helps troubleshoot issues.',
	Ai_Sidebar_AboutDescription2:
		'Note that AI may provide inaccurate or incomplete information. We recommend checking responses with the provided source material.',
	Ai_Sidebar_About_Legal_Information: 'Legal Information',
	Privacy: 'Privacy',
	Terms_of_Use: 'Terms of Use',
	Ai_Sidebar_About_Your_Data: 'Your data',
	Ai_Sidebar_About_Your_Data_Description:
		'Barracuda cares about your data and gives you control to delete your past chat data. When your history is deleted it will reset the AI and no longer retain your past interactions with Bailey.',
	Delete_Chat_History: 'Delete chat history',
	Delete_Chat_History_Confirmation:
		'Deleting your chat history will erase all your data and prevent you from accessing past conversations.',
	Delete_Confirm: 'Delete',
	Delete_Cancel: 'Cancel',
	Chat_History_Deleted: 'Chat history deleted',
	Chat_History_Deletion_Failed: 'Chat history deletion failed',
	Copied: 'Copied',
	More_Options: 'More options',
	Select_All: 'Select all',
	Deselect_All: 'Deselect all',
};

export const enUSSuggestions = [
	{
		text: 'How do I start a scan in Data Inspector?',
		description: 'Get an overview of how scanning works in Data Inspector',
	},
	{
		text: 'What types of data will Data Inspector report on?',
		description:
			'Learn more about the types of sensitive data Data Inspector provides visibility into',
	},
	{
		text: 'How can I use policies to automate remediation of detections?',
		description:
			'Learn more about how policies can be used to reduce the work necessary to protect sensitive data',
	},
	{
		text: 'How can I create a custom classifier?',
		description:
			'Learn about how to create custom classifiers for your unique use cases',
	},
	{
		text: 'What does quarantine do in remediation?',
		description:
			'Get more details on what happens when a file is quarantined in Data Inspector',
	},
	{
		text: 'What does unshare do in remediation?',
		description:
			'Get more details on what happens when a file is unshared in Data Inspector',
	},
];
